/* eslint-disable import/no-unresolved */
import ecommerceStripe from '@blaze-cms/plugin-ecommerce-stripe-fe';
import ecommerceComponents from '@blaze-cms/plugin-ecommerce-components';
import ecommerceGtm from '@blaze-cms/plugin-ecommerce-gtm-fe';
import shopware from 'blaze-kelsey-plugin-frontend-shopware';
import campaign from 'blaze-kelsey-plugin-frontend-campaign';
import ecommercePosthog from '@blaze-cms/plugin-ecommerce-posthog-fe';
import posthog from 'blaze-kelsey-plugin-frontend-posthog';

export default function buildProjectConfig(config) {
  // core Blaze plugins
  config.plugins.set(ecommerceStripe, {});
  config.plugins.set(ecommerceComponents, {});
  config.plugins.set(ecommerceGtm, {
    itemIdProperty: 'label', // 'label',
    itemNameProperty: 'name', // 'name',
    itemProperties: ['thirdPartyIdentifier'],
    brandProperty: null, // 'brands.name',
    categoryProperties: ['category.name'], // 'productType.name',
    orderIdProperty: 'reference' // 'orderNumber',
  });
  // PostHog loaded and initialised in code (KEL-253), consent from Didomi. The ecommerce plugin
  // sends events to it directly (default posthog transport)
  config.plugins.set(posthog, {
    apiKey: process.env.BLAZE_POSTHOG_PROJECT_KEY,
    apiHost: process.env.BLAZE_POSTHOG_API_HOST,
    uiHost: process.env.BLAZE_POSTHOG_UI_HOST,
    debug: process.env.BLAZE_POSTHOG_DEBUG === 'true',
    // dev and stage share a parent domain, so a cross subdomain cookie would mix their PostHog
    // ids. On for prod only unless BLAZE_POSTHOG_CROSS_SUBDOMAIN_COOKIE is set
    crossSubdomainCookie: process.env.BLAZE_POSTHOG_CROSS_SUBDOMAIN_COOKIE
      ? process.env.BLAZE_POSTHOG_CROSS_SUBDOMAIN_COOKIE === 'true'
      : process.env.BLAZE_STAGE === 'prod',
    // added to every event, environment variables override the defaults
    superProperties: {
      site_id: process.env.BLAZE_POSTHOG_SITE_ID || 'SHOP',
      site_name: process.env.BLAZE_POSTHOG_SITE_NAME || 'Kelsey Shop',
      site_brand_id: process.env.BLAZE_POSTHOG_SITE_BRAND_ID || 'KEL_SHOP',
      site_brand_name: process.env.BLAZE_POSTHOG_SITE_BRAND_NAME || 'Kelsey Shop'
    },
    // campaign url params on every event in the browser session, as campaign_offer,
    // campaign_source and campaign_channel. PostHog's own utm_* capture is unchanged
    sessionParams: ['offer', 'source', 'channel'],
    // Cookieless capture after consent is rejected, approved by Kelsey (2026-10-09)
    captureOnReject: true,
    // Didomi "Analytics" purpose (custom purpose analytics_tracking in Kelsey's notice). Add a
    // PostHog custom vendor id (c:posthog-...) to vendors if Kelsey add PostHog to Didomi
    consent: { mode: 'didomi', purposes: ['analytics_tracking'], vendors: [] }
  });
  config.plugins.set(ecommercePosthog, {});

  // project plugins
  config.plugins.set(shopware, {});
  // Campaign parameter capture (KEL-387). Consent is assumed until Kelsey confirm
  // the basis; switch to { mode: 'didomi', purposes: [...], vendors: [...] } then.
  config.plugins.set(campaign, {
    attribution: 'first',
    expiryDays: 30,
    consent: { mode: 'assumed' }
  });

  return config;
}
